import './AdditionalInformationTitle.scss';

interface AdditionalInformationTitleProp {
  title: string;
  subHeader: string;
}

function AdditionalInformationTitle({ title, subHeader }: AdditionalInformationTitleProp) {
  return (
    <>
      <div className="additional-information-header">
        <div className="additional-information-header-title">{title}</div>
      </div>
      <div className="additional-information-sub-header-message ">
        We are currently featuring your location and are actively working to add high quality homes to our site. Submitting the following form will
        give our homeowner care team all they need to prepare for a discussion with you on our services. You’ll also find a calculator that can
        estimate the revenue potential of a home like yours. Someone from Urbain will be in contact shortly.
      </div>
      <div className="additional-information-sub-header">
        <div className="tag-line">{subHeader}</div>
      </div>
    </>
  );
}
export default AdditionalInformationTitle;
